import { notFoundRouteCase, Updater } from 'widgets-for-react'
import { CurrentPage } from '../../../utils/routes'
import { RootState } from '../rootState'
import { SearchTab } from '../search/searchState'
import { Pages, routeUpdaters } from './routesState'
import { routeWidgets } from './routesWidget'

export const parsePageParam = (param?: string): number => {
  if (!param) return 1
  const paramNumber = parseInt(param)
  return paramNumber > 0 ? paramNumber : 1
}

export const parseCategoryParam = (param?: string): SearchTab =>
  param === 'blogs' ||
  param === 'knowledge' ||
  param === 'collections' ||
  param === 'dishes'
    ? param
    : 'components'

export const parseArrayParam = (param?: string | string[]) =>
  param === undefined ? [] : typeof param === 'string' ? [param] : param

export const isDifferentPage = (
  oldPage: CurrentPage<Pages>,
  newPage: CurrentPage<Pages>
) =>
  oldPage.kind !== newPage.kind ||
  (oldPage.kind === 'componentDetail' &&
    newPage.kind === 'componentDetail' &&
    oldPage.params.componentIdAndName !== newPage.params.componentIdAndName) ||
  (oldPage.kind === 'componentEdit' &&
    newPage.kind === 'componentEdit' &&
    oldPage.params.componentId !== newPage.params.componentId) ||
  (oldPage.kind === 'blogDetail' &&
    newPage.kind === 'blogDetail' &&
    oldPage.params.blogSlug !== newPage.params.blogSlug) ||
  (oldPage.kind === 'knowledgeDetail' &&
    newPage.kind === 'knowledgeDetail' &&
    oldPage.params.knowledgeSlug !== newPage.params.knowledgeSlug) ||
  (oldPage.kind === 'page' &&
    newPage.kind === 'page' &&
    oldPage.params.pageSlug !== newPage.params.pageSlug) ||
  (oldPage.kind === 'collectionDetail' &&
    newPage.kind === 'collectionDetail' &&
    oldPage.params.collectionId !== newPage.params.collectionId) ||
  (oldPage.kind === 'knowledgeTypeOverview' &&
    newPage.kind === 'knowledgeTypeOverview' &&
    oldPage.params.knowledgeTypeTitle !== newPage.params.knowledgeTypeTitle) ||
  (((oldPage.kind === 'blogOverview' && newPage.kind === 'blogOverview') ||
    (oldPage.kind === 'dishesOverview' && newPage.kind === 'dishesOverview') ||
    (oldPage.kind === 'componentOverview' &&
      newPage.kind === 'componentOverview') ||
    (oldPage.kind === 'search' && newPage.kind === 'search') ||
    (oldPage.kind === 'dashboard' && newPage.kind === 'dashboard') ||
    (oldPage.kind === 'collectionDetail' &&
      newPage.kind === 'collectionDetail')) &&
    oldPage.params.page !== newPage.params.page)

export const routesArray = (language: string) => {
  const localizedRouteWidgets = routeWidgets(language)

  return [
    localizedRouteWidgets.homeRedirect,
    localizedRouteWidgets.home,
    localizedRouteWidgets.componentOverview,
    localizedRouteWidgets.componentEdit,
    localizedRouteWidgets.componentDetail,
    localizedRouteWidgets.blogOverview,
    localizedRouteWidgets.blogDetail,
    localizedRouteWidgets.search,
    localizedRouteWidgets.dashboard,
    localizedRouteWidgets.collectionDetail,
    localizedRouteWidgets.knowledgeDetail,
    localizedRouteWidgets.knowledgeTypeOverview,
    localizedRouteWidgets.knowledgeOverview,
    localizedRouteWidgets.seasonalCalendar,
    localizedRouteWidgets.contact,
    localizedRouteWidgets.dishesOverview,
    localizedRouteWidgets.dishesDetail,

    localizedRouteWidgets.accountDetails,
    localizedRouteWidgets.upgrade,

    localizedRouteWidgets.subscriptionSuccessRedirect,
    localizedRouteWidgets.subscriptionFailureRedirect,
    localizedRouteWidgets.subscriptionCancelRedirect,
    localizedRouteWidgets.changePaymentMethodSuccessRedirect,
    localizedRouteWidgets.changePaymentMethodFailureRedirect,
    localizedRouteWidgets.changePaymentMethodCancelRedirect,
    localizedRouteWidgets.payOpenInvoiceSuccessRedirect,
    localizedRouteWidgets.payOpenInvoiceFailureRedirect,
    localizedRouteWidgets.payOpenInvoiceCancelRedirect,
    localizedRouteWidgets.subscriptionSuccess,
    localizedRouteWidgets.subscriptionFailure,
    localizedRouteWidgets.subscriptionCancel,
    localizedRouteWidgets.subscriptionStopPayment,
    localizedRouteWidgets.changePaymentMethodSuccess,
    localizedRouteWidgets.changePaymentMethodFailure,
    localizedRouteWidgets.changePaymentMethodCancel,
    localizedRouteWidgets.payOpenInvoiceSuccess,
    localizedRouteWidgets.payOpenInvoiceFailure,
    localizedRouteWidgets.payOpenInvoiceCancel,

    localizedRouteWidgets.register,
    localizedRouteWidgets.registerStudent,
    localizedRouteWidgets.registerPromo,
    localizedRouteWidgets.activateAccount,
    localizedRouteWidgets.resetPassword,
    localizedRouteWidgets.requestResetPassword,
    localizedRouteWidgets.login,
    localizedRouteWidgets.logout,

    localizedRouteWidgets.studentSubscription,
    localizedRouteWidgets.updatePayment,
    localizedRouteWidgets.updatePaymentRedirect,
    localizedRouteWidgets.thankYouUpdatePayment,

    //keep this one in the end!
    localizedRouteWidgets.page,

    notFoundRouteCase<Updater<RootState>>(
      routeUpdaters(language).notFound.jumpTo
    ),
  ]
}
